module.exports = TalendReactComponents;